import {
  css,
  DefaultTheme,
  FlattenInterpolation,
  Interpolation,
  ThemedStyledProps
} from 'styled-components';
import themeContract from '../providers/Theme/themeContract.json';

// `:root[data-theme='light'] &` never matches under styled-components scoping; `:is()` does.
export const LIGHT_THEME_SELECTOR = themeContract.lightSelector;

export const onLightTheme = <P extends object = object>(
  strings: TemplateStringsArray,
  ...interpolations: Interpolation<ThemedStyledProps<P, DefaultTheme>>[]
): FlattenInterpolation<ThemedStyledProps<P, DefaultTheme>> => css`
  &${LIGHT_THEME_SELECTOR} {
    ${css(strings, ...interpolations)}
  }
`;

export const MUTED_LIGHT_INK = 'var(--ln-content-muted)';
export const LIGHT_DIM_OPACITY = 0.7;

export const lightDim = onLightTheme`
  opacity: ${LIGHT_DIM_OPACITY};
`;

// Text dimmed by opacity alone falls under 4.5:1 on a light card; lift it to a legible floor.
export const LIGHT_TEXT_OPACITY_FLOOR = 0.7;

export const lightTextFloor = (opacity: number) =>
  opacity < LIGHT_TEXT_OPACITY_FLOOR
    ? onLightTheme`
        opacity: ${LIGHT_TEXT_OPACITY_FLOOR};
      `
    : null;
